export default "__VITE_ASSET__DQzbZfcP__"